import API from "../api"

const SettingService = {
  getSettings: () => API.get(`org/setting`),
  updateSettings: (newSettingsMap) => API.post(`org/setting`, newSettingsMap),
};

export default SettingService;
